import { render, staticRenderFns } from "./SectionPanel.vue?vue&type=template&id=b913ced4&scoped=true"
import script from "./SectionPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionPanel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SectionPanel.vue?vue&type=style&index=0&id=b913ced4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b913ced4",
  null
  
)

export default component.exports